enum UserIntegrationStatus {
	ACTIVE = "active",
	INACTIVE = "inactive",
	IN_SETUP = "in_setup",
	FAILED_SETUP = "failed_setup",
}

namespace UserIntegrationStatus {
	const names = {
		[UserIntegrationStatus.ACTIVE]: "Active",
		[UserIntegrationStatus.INACTIVE]: "Inactive",
		[UserIntegrationStatus.IN_SETUP]: "Setup required",
		[UserIntegrationStatus.FAILED_SETUP]: "Setup failed",
	};

	const colors = {
		[UserIntegrationStatus.ACTIVE]: "green",
		[UserIntegrationStatus.INACTIVE]: "red",
		[UserIntegrationStatus.IN_SETUP]: "red",
		[UserIntegrationStatus.FAILED_SETUP]: "red",
	};

	export const display = (status: UserIntegrationStatus) => names[status];

	export const color = (status: UserIntegrationStatus) => colors[status];
}

export { UserIntegrationStatus };
